import { useState } from "react";
import { PageIdAdd } from "./PageIdAdd";
import { PageIdTable } from "./PageIdTable";
import { CommunicationBindingDelete } from "../CommunicationBindingDelete";
import { Heading } from "V2.0/common/heading";

function PageIdBinding(props) {
  const {
    isOpen,
    onClose,
    onBindingAdd,
    pageIds,
    communicationBinding,
    onBindingConfirmDelete,
    onBindingDelete,
    locked
  } = props;

  return (
    <>
      <div className="flex flex-col w-1/3 mx-auto mt-4 p-4 gap-y-4 h-full min-h-0">
        <div className="w-full flex items-center justify-between">
          <Heading>Pages</Heading>
          {!locked && <PageIdAdd onPageIdAdd={onBindingAdd} pageIds={pageIds} />}
        </div>
        <PageIdTable
          communicationBinding={communicationBinding}
          onItemDelete={onBindingDelete}
          showActions={!locked}
        />
      </div>
      {isOpen && (
        <CommunicationBindingDelete
          open={true}
          onClose={onClose}
          title="Remove Page"
          onDelete={onBindingConfirmDelete}
        />
      )}
    </>
  );
}

export { PageIdBinding };
